import { render, staticRenderFns } from "./registerStep2.vue?vue&type=template&id=9469ab86&scoped=true"
import script from "./registerStep2.vue?vue&type=script&lang=js"
export * from "./registerStep2.vue?vue&type=script&lang=js"
import style0 from "./registerStep2.vue?vue&type=style&index=0&id=9469ab86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9469ab86",
  null
  
)

export default component.exports